import { Expose } from 'class-transformer';

export class UserGadgetItemApiModel {
  @Expose()
  id: string;

  @Expose()
  salesDocumentId: string;

  @Expose()
  itemId: string;

  @Expose()
  name: string;

  @Expose()
  price: number;

  @Expose()
  quantity: number;

  @Expose()
  value: number;

  @Expose()
  voucherNumber: string;

  @Expose()
  voucherName: string;

  @Expose()
  voucherBatchName: string;
}
